import type { App } from 'vue';
import { authDirective } from '/@/directive/authDirective';
import { roleDirective } from '/@/directive/roleDirective';
import { wavesDirective, dragDirective } from '/@/directive/customDirective';

/**
 * 导出指令方法：v-xxx
 * @methods authDirective 用户权限指令，用法：v-auth
 * @methods roleDirective 角色权限指令（基于 roleCode），用法：v-role、v-role-exclude
 * @methods wavesDirective 按钮波浪指令，用法：v-waves
 * @methods dragDirective 自定义拖动指令，用法：v-drag
 */
export function directive(app: App) {
	// 用户权限指令
	authDirective(app);
	// 角色权限指令（基于 Local.get('roleCode')）
	roleDirective(app);
	// 按钮波浪指令
	wavesDirective(app);
	// 自定义拖动指令
	dragDirective(app);
}
